import React from "react";
import diaticsLogo from '../../assets/images/custom/diaticsLogo.png';

const Footer = props => {

    function redirectDiatics() {
        window.location.assign('https://diatics.com');
    }

    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6 footer-copyright">
                        <p className="mb-0">Edgemon</p>
                    </div>
                    <div className="col-md-6 d-flex justify-content-end" onClick={() => redirectDiatics()} style={{ cursor: "pointer" }} >
                        <img alt="diatics" src={diaticsLogo} style={{ width: "13%" }} /> | v1.1.0-26.08.1
                    </div>
                </div>
            </div>
        </footer>
    )
};

export default Footer;